var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"pw-button",class:_vm.internalClass},_vm.$listeners),[_c('span',[(_vm.icon)?_c('span',{staticClass:"pw-button-icon"},[_c('i',{staticClass:"mdi",class:'mdi-' + _vm.icon})]):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }